module.exports = __webpack_public_path__ + "img/feature_buy_zh.62d343d7.png";